

export const setcallInfo = (callinfo) => ({
    type: 'SET_CALLINFO',
    payload: callinfo,
  });


  
 
  